module["exports"] = [
  "com",
  "az",
  "com.az",
  "info",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/internet/domain_suffix.js
// module id = 185
// module chunks = 0